/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Empty_No_TemplateInputs */

const cs_draft_empty_no_template = /** @type {(inputs: Draft_Empty_No_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte šablonu výše, zkontrolujte automaticky vyplněná data a pak Generovat.`)
};

const en_draft_empty_no_template = /** @type {(inputs: Draft_Empty_No_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a template above to review autofilled listing data, then Generate.`)
};

/**
* | output |
* | --- |
* | "Choose a template above to review autofilled listing data, then Generate." |
*
* @param {Draft_Empty_No_TemplateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_empty_no_template = /** @type {((inputs?: Draft_Empty_No_TemplateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Empty_No_TemplateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_empty_no_template(inputs)
	return cs_draft_empty_no_template(inputs)
});